
const ReportingGroupMemberType = {
  MEMBER: 0,
  EXCLUDE: 1
}

export {
  ReportingGroupMemberType
}



// WEBPACK FOOTER //
// ./src/enums/ReportingGroupMemberType.js